import styled from 'styled-components';
import {
    Info,
    InfoTextTooltip,
} from './workflow-modal-tooltip.styles';

export const verticalAlignmentOptions = {
    top: {
        borderTop: '5px solid #261f41',
        borderBottom: '0',
        top: '100%',
        bottom: 'unset',
    },
    bottom: {
        borderTop: '0',
        borderBottom: '5px solid #261f41',
        top: 'unset',
        bottom: '100%',
    },
};


export const placementsOptions = {
    right: {
        transform: 'translateX(-15px)',
        right: 'unset',
        after: {
            left: '15px',
            right: 'unset',
        },
    },
    left: {
        transform: 'translateX(-15px)',
        right: '-100%',
        after: {
            left: 'unset',
            right: '5px',
        },
    },
    center: {
        transform: 'translateX(-50%)',
        right: 'unset',
        after: {
            left: '50%',
            right: 'unset',
        },
    },
};

export const StyledInfo = styled(Info)`
    width: 100%;
    text-align: center;
`;

export const StyledInfoTextTooltip = styled(InfoTextTooltip)`
    padding: 5px 10px;
    position: absolute;
    line-height: 14px;
    transform: ${props => props.placementCSS.transform};
    right: ${props => props.placementCSS.right};
    ${({ stylesToolTip }) => stylesToolTip && { ...stylesToolTip }};

    &::after {
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: ${props => props.verticalAlignmentCSS.borderTop};
        border-bottom: ${props => props.verticalAlignmentCSS.borderBottom};
        content: '';
        left: ${props => props.placementCSS.after.left};
        right: ${props => props.placementCSS.after.right};
        transform: translateX(-50%);
        position: absolute;
        top: ${props => props.verticalAlignmentCSS.top};
        bottom: ${props => props.verticalAlignmentCSS.bottom};
        width: 0px;
    }
`;
